import React, { useState } from 'react';
import './styles/EVStation.css';
import upArrow from '../../assets/icons/up-arrow.svg';
import downArrow from '../../assets/icons/down-arrow.svg';

const EVStationInfo = ({ station }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Determine if there are any details to show
  const hasDetails = (
    (station.opening_hours && station.opening_hours.trim() !== '') ||
    (station.charger_capacities && station.charger_capacities.trim() !== '' && station.charger_capacities.trim().toLowerCase() !== 'kw') ||
    (station.operator && station.operator.trim() !== '')
  );

  const toggleExpanded = () => {
    setIsExpanded(expanded => !expanded);
  };

  return (
    <div className="ev-station-info">
      <div className="ev-station-title" onClick={toggleExpanded}>
        {station.station_address} 
        {hasDetails && (
          <button
            className={`ev-station-more-btn${isExpanded ? ' expanded' : ''}`}
            aria-label={isExpanded ? 'Collapse details' : 'Expand details'}
          >
            <img
              className="ev-station-more-dots"
              src={downArrow}
              alt={isExpanded ? 'Collapse' : 'Expand'}
              width={24}
              height={24}
            />
          </button>
        )}
      </div>
      <div className={`ev-station-details${isExpanded ? '' : ' ev-station-details-collapsed'}`}> 
        {station.opening_hours && (
          <div>
            <span className="ev-station-label">Opening hours</span>
            <div className="ev-station-detail-value">{station.opening_hours}</div>
          </div>
        )}
        {station.charger_capacities && station.charger_capacities.trim().toLowerCase() !== 'kw' && station.charger_capacities.trim() !== '' && (
          <div>
            <span className="ev-station-label">Charging Capacity</span>
            <div className="ev-station-detail-value">{station.charger_capacities}</div>
          </div>
        )}
        {station.operator && (
          <div>
            <span className="ev-station-label">Operator</span>
            <div className="ev-station-detail-value">{station.operator}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EVStationInfo; 